<template>
  <div class="modal_wrap" :class="{ on: show }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">앱 접근 권한 안내</h1>
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <div>
              <div class="access_box">
                <i class="i_location"></i>
                <div class="con">
                  <!--<div class="ttl on">위치<small>(선택)</small></div>-->
                  <div class="ttl">위치<small>(선택)</small></div>
                  <div class="txt">
                    사용자 주변 매장을 추천 받기 위해 필요한 권한
                  </div>
                </div>
              </div>
              <div class="access_box">
                <i class="i_camera"></i>
                <div class="con">
                  <div class="ttl">
                    카메라/저장공간 읽기<small>(선택)</small>
                  </div>
                  <div class="txt">
                    프로필 사진 변경, 상담 중 이미지 전달을 위해 필요한 권한
                  </div>
                </div>
              </div>
              <div class="access_box">
                <i class="i_call"></i>
                <div class="con">
                  <div class="ttl">전화 걸기 및 관리<small>(선택)</small></div>
                  <div class="txt">
                    매장 연락 및 요청서 작성 중 통신사와 기기명 가져오기 위해
                    필요한 권한
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn" @click="$emit('close')">확인</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppAccessAuthorityModal',
  props: {
    show: Boolean,
  },
};
</script>

<style scoped></style>
